export const MARGIN_MAP = {
    1: 'tw-ml-2',
    2: 'tw-ml-4',
    3: 'tw-ml-6'
};